import Loadable from '@townsquare/loadable';

export const HomeApp = Loadable({
	loader: () => import(/* webpackChunkName: "home-app-entry" */ '../App'),
	loading: () => null,
});
